import type { AssignedQuizFilters } from '@repo/types/pagination';

import { useInfiniteQuery } from '@tanstack/react-query';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

interface UseGetAssignedQuizzesInfiniteProps {
  name?: string;
  filter?: AssignedQuizFilters;
  groupId?: number;
  enabled?: boolean;
}

export function useGetAssignedQuizzesInfinite(useGetAssignedQuizzesInfiniteProps: UseGetAssignedQuizzesInfiniteProps) {
  const { name, filter, groupId, enabled = true } = useGetAssignedQuizzesInfiniteProps;
  return useInfiniteQuery({
    queryKey: [QuizKey.QUIZZES_INFINITE, name, filter, groupId],
    enabled: enabled,
    queryFn: ({ pageParam }) =>
      QuizService.getAssignedQuizzes({
        ...pageParam,
        name: name,
        filter: filter,
        groupId: groupId,
      }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, name: undefined },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}
